<template>
    <div v-wechat-title="title" style="height: 100%">
        <!--:updateButton="{enabled:false}"
    :addButton="{enabled:false}"
    :deleteButton="{enabled:false}"-->
        <crud-facecade
            ref="crud2"
            :url="init.url"
            :columns="columnList"
            :buttons="buttons"
            @ResetPassword="ResetPassword"
            :tableHeight="tableHeight"
            :addButton="{ enabled: false, permission: 'user:create' }"
            :deleteButton="{ permission: 'user:update' }"
            :updateButton="{ enabled: false, permission: 'user:delete' }"
            @AssignRoles="AssignRoles"
            @LoadingRegion="LoadingRegion"
        >
                    <template slot="filter-after">
                <el-button type="primary" size="mini" v-has-permission="resetAllPasswordPermission"  @click="resetAllPassword()">重置所有密码</el-button>

            </template>
            <!--<el-row slot="header">
      <el-col :span="4">{{headerName}}</el-col>
    </el-row>-->
        </crud-facecade>
        <!--修改密码区域-->
        <!-- <AlterPassword :visible.sync="alterPasswordDialog.dialogFormVisible" :userid="alterPasswordDialog.userid"></AlterPassword> -->
        <!--分配juese-->
        <form-dialog
            ref="ruleForm3"
            :title="assignRolesDialog.title"
            :data="assignRolesDialog.data"
            :visible.sync="assignRolesDialog.dialogFormVisible"
            :columns="assignRolesDialog.columns"
            @confirm="SaveRoles"
        ></form-dialog>
        <tree-dialog
            :title="assignRegion.title"
            :strictly="true"
            :visible.sync="assignRegion.dialogFormVisible"
            :data="assignRegion.data"
            :default-checked-keys="assignRegion.defaultCheckedKeys"
            @confirm="SaveRegion"
        >
            <template slot="row" slot-scope="{ node, data }">
                <span>{{ data.name }}</span>
                <span>
                    {{ data.path }}
                </span>
            </template>
        </tree-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AlterPassword from './AlterPassword.vue'
export default {
    name: `User`,
    components: { AlterPassword },
    data() {
        return {
            title: `用户管理`,
            init: {
                url: `/api/AcisSystem/SysUser`
            },
            alterPasswordDialog: {
                dialogFormVisible: false,
                userid: 0
            },
            buttons: [],
            assignRolesDialog: {
                title: `分配角色`,
                dialogFormVisible: false,
                data: { userId: 0, roles: [] },
                columns: [{
                    type: `checkboxgroup`,
                    prop: `roles`,
                    label: `角色:`,
                    options: [],
                    colspan: 24
                }]
            },
            assignRegion: {
                title: `分配区域`,
                dialogFormVisible: false,
                data: [],
                userId: undefined,
                defaultCheckedKeys: []
            },
            defaultPassword: this.$root.ResetDefaultPassword,
            resetAllPasswordPermission: `user:resetallpassword` // 调整所有密码
        }
    },
    created() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`sysuser/ADD_ROLES`)
        this.$store.dispatch(`ADD_HOSPITAL_WARD`)
        this.$store.dispatch(`ADD_OPERATION_WARD`)
        this.$store.dispatch(`ADD_RECOVERY_WARD`)
    },
    computed: {
        ...mapGetters([`sysuser/workers`, `sysuser/roles`, `hospital_ward_all`, `operation_ward_all`, `recovery_ward_all`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        workers() {
            return this[`sysuser/workers`]
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `card_no`,
                label: `工号`,
                width: `120`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: false,
                sortable: true
            }, {
                type: `string`,
                prop: `dic_worker_name`,
                label: `姓名`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: false,
                sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `sex`,
                label: `性别`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: true,
                isKey: false,
                options: `sex`,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `username`,
                label: `登录名`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: false,
                readonly: false,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `password`,
                label: `密码`,
                width: `300`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: true,
                isKey: false,
                default: `123456`,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                readonly: false,
                options: `is_enabled`,
                default: true
            }, {
                type: `select`,
                prop: `dic_worker_id`,
                label: `员工ID`,
                width: `80`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: true,
                searchable: false,
                isKey: false,
                options: this.workers
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `260`,
                fixed: `right`,
                readonly: false,
                isListable: true,
                options: [{
                    class: `is-plain`,
                    label: `分配角色`,
                    type: `primary`,
                    emit: `AssignRoles`,
                    permission: `default`// user:assignRole
                }, {
                    class: `is-plain`,
                    label: `所属区域`,
                    type: `primary`,
                    emit: `LoadingRegion`,
                    permission: `default`// user:assignRole
                }, {
                    class: `is-plain`,
                    label: `重置密码`,
                    type: `primary`,
                    emit: `ResetPassword`,
                    permission: `default`// user:assignRole
                }]
            }]
        }
    },
    methods: {
        resetAllPassword() {
            if (!this.defaultPassword || this.defaultPassword.trim() == ``) {
                this.$message.error(`重置密码失败,请联系管理员设置初始密码[参数:ResetDefaultPassword]`)
                return
            }
            var password = this.defaultPassword
            this.$confirm(`是否重置所有用户密码?(初始密码${password}),请谨慎操作`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                this.myaxios.post(`/api/AcisSystem/SysUser/ResetAllUserPassword`)
                    .then((response) => {
                        this.$message.success(`重置密码成功`)
                    }, (res) => {
                        console.log(res)
                    })
            })
        },
        ResetPassword({ row, index }) {
            if (!this.defaultPassword || this.defaultPassword.trim() == ``) {
                this.$message.error(`重置密码失败,请联系管理员设置初始密码[参数:ResetDefaultPassword]`)
                return
            }
            var password = this.defaultPassword
            this.$confirm(`是否重置密码?(初始密码${password})`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                this.myaxios.post(`/api/AcisSystem/SysUser/ResetPassword/${row.id}`)
                    .then((response) => {
                        this.$message.success(`重置密码成功`)
                    }, (res) => {
                        console.log(res)
                    })
            })
        },
        AssignRoles({ row, index }) {
            this.myaxios.get(`/api/AcisSystem/SysUser/GetRoles`, { username: row.username })
                .then((data) => {
                    let roleIds = data.map(r => r.id)
                    this.assignRolesDialog.data.roles = roleIds || []
                    this.assignRolesDialog.dialogFormVisible = true
                }, (res) => {
                    console.log(res)
                })
            this.assignRolesDialog.columns[0].options = this[`sysuser/roles`]
            this.assignRolesDialog.data.user = row
            this.assignRolesDialog.data.userId = row.id
        },
        SaveRoles(data) {
            let that = this
            let roleList = []
            data.roles.forEach(function(roleId) {
                if (roleId) { roleList.push({ user_id: that.assignRolesDialog.data.userId, role_id: roleId }) }
            })
            this.myaxios.post(`/api/AcisSystem/SysUser/AssignRoles`, roleList)
                .then((data) => {
                    that.assignRolesDialog.dialogFormVisible = false
                    // that.$refs["crud2"].QueryListData()
                }, (res) => {
                    console.log(res)
                })
        },
        LoadingRegion({ row, index }) {
            let that = this
            that.assignRegion.userId = row.id
            that.assignRegion.data = _.map(that.hospital_ward_all, h => {
                h.operation_ward = _.filter(that.operation_ward_all, { dic_hospital_ward_id: h.id, is_deleted: false }).map(w => {
                    return {
                        id: `SSQ${w.id}`,
                        _id: w.id,
                        name: `${w.name}  ( 手术间数: ${w.operation_room.length} )`,
                        path: `手术区`,
                        enum_region_type: 1
                        // nocheck:true,
                    }
                })
                h.recovery_ward = _.filter(that.recovery_ward_all, { dic_hospital_ward_id: h.id, is_deleted: false }).map(w => {
                    return {
                        id: `SXQ${w.id}`,
                        _id: w.id,
                        name: `${w.name}  ( 床位数: ${w.recovery_bed.length} )`,
                        path: `苏醒区`,
                        enum_region_type: 2
                        // nocheck:true,
                    }
                })

                return {
                    id: `YQ${h.id}`,
                    _id: h.id,
                    name: h.name,
                    path: `院区`,
                    enum_region_type: 0,
                    children: h.operation_ward.concat(h.recovery_ward)
                }
            })
            that.assignRegion.defaultCheckedKeys = []
            that.assignRegion.dialogFormVisible = true
            let req1 = this.myaxios.get(`/api/AcisSystem/SysUser/GetRegions?username=${row.username}`)// 获取区域
            req1.then(data => {
                let hp = data.hospital_wards.map(d => { return `YQ${d.id}` })
                let ow = data.operating_wards.map(d => { return `SSQ${d.id}` })
                let rw = data.recovery_wards.map(d => { return `SXQ${d.id}` })
                that.assignRegion.defaultCheckedKeys = hp.concat(ow).concat(rw)
            })
        },
        SaveRegion(e) {
            let that = this
            let checkedPerms = e.map((v) => {
                return { region_id: v._id, user_id: this.assignRegion.userId, enum_region_type: v.enum_region_type }
            })
            this.myaxios.post(`/api/AcisSystem/SysUser/AssignRegion`, checkedPerms)
                .then((data) => {
                    that.assignRegion.dialogFormVisible = false
                }, (res) => {
                    console.log(res)
                })
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SysUser/Index.vue